export const wrapper = {
  md: '880px',
  lg: '1024px',
};
